import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { DueDiligenceApi } from "../../../../../apis/due-diligence.api";
import { ValidationController, ValidationControllerFactory, ValidationRules } from "aurelia-validation";
import { CustomValidationRenderer } from "@rightship-tech/common-ui/client-validation-system/custom-validation-renderer";
import { CollaboratorEmail, GetCollaboratorsResponse } from "../../../../../models/due-diligence.models";
import { GoogleAnalyticsService } from "@rightship-tech/common-ui/services/analytics/google-analytics.service";
import { VesselDetailModel } from '../../../../../models/vessel.models';

@autoinject
@transient()
export class DialogManageCollaborators {

    private _validator: ValidationController;
    private _vessel: VesselDetailModel;
    public vetId: number;
    public response: GetCollaboratorsResponse;

    constructor(private dialogClient: DialogClientService, private dueDiligenceApi: DueDiligenceApi, validationControllerFactory: ValidationControllerFactory,
        private googleAnalyticsService: GoogleAnalyticsService) {
        this._validator = validationControllerFactory.createForCurrentScope();
        this._validator.addRenderer(new CustomValidationRenderer());
    }

    activate(model: { vetId: number, collaborators: GetCollaboratorsResponse, vessel }) {
        this.vetId = model.vetId;
        this.response = model.collaborators;
        this._vessel = model.vessel;
    }

    //Close
    public close() {
        this.dialogClient.hide();
    }

    //Get validation rules
    private getRules() {
        let validationRules = ValidationRules
            .ensure<CollaboratorEmail, string>(x => x.email)
            .required()
            .withMessage("Email is required")
            .ensure(x => x.email)
            .email()
            .withMessage("Email not in correct format");
           
        return validationRules
            .rules;
    }

    //Is validation rules valid
    public async isValid(): Promise<boolean> {
        const rules = this.getRules();
        let isValid = true;
        for (const collaborator of this.response.collaborators) {
            const validationResponse = await this._validator.validate({ object: collaborator, rules: rules });
            isValid = isValid || validationResponse.valid;
            if(!isValid) {
                break;
            }
        }
        return isValid;
    }

    //Save
    public async save() {
        const isValid = await this.isValid();
        if (isValid) {
            await this.dueDiligenceApi.saveCollaborators(this.vetId, this.response.collaborators);
            this.dialogClient.hide();
            this.response = await this.dueDiligenceApi.getCollaborators(this.vetId);
        }
    }

    //Add collaborator
    public addCollaborator() {
        this.response.collaborators.push({ email: "" });

        //Send event to google analytics
        this.googleAnalyticsService.sendCustomGA4EventMulti("ddh_collaborator_engagement_manage_dialog", {
            "vesselName": this._vessel.name ?? "N/a",
            "vesselImo": this._vessel.internationalMaritimeOrganizationNumber ?? "N/a",
            "vesselType": this._vessel.vesselType ?? "N/a"
        });
    }

    //Remove collaborator
    public removeCollaborator(index: number) {
        this.response.collaborators.splice(index, 1);
    }
}